/**
 * Renders the assistance-specific field set for a given assistance type.
 * Shared between the visit wizard's Assistance Form step and the visit edit
 * page, so both places render identical fields for a given transaction type.
 */

import { UseFormReturn } from 'react-hook-form'
import type { AssistanceType } from '@/types/visit-wizard'
import { LegalCounsellingForm } from './LegalCounsellingForm'
import { DocumentationForm } from './DocumentationForm'
import { OathAdministeredForm } from './OathAdministeredForm'
import { JailVisitForm } from './JailVisitForm'
import { MediationConciliationForm } from './MediationConciliationForm'
import { AdministrativeCaseForm } from './AdministrativeCaseForm'
import { ProsecutorsOfficeForm } from './ProsecutorsOfficeForm'
import { LaborCasesForm } from './LaborCasesForm'
import { OutreachForm } from './OutreachForm'
import { RepresentationCourtForm } from './RepresentationCourtForm'
import { RepresentationAppellateForm } from './RepresentationAppellateForm'

interface AssistanceDetailFieldsProps {
  assistanceType: AssistanceType
  form: UseFormReturn<any>
  isView?: boolean
  courts?: Array<{ court: string; code: string }>
  officeCodes?: string[]
}

export function AssistanceDetailFields({
  assistanceType,
  form,
  isView,
  courts = [],
  officeCodes = [],
}: AssistanceDetailFieldsProps) {
  switch (assistanceType) {
    case 'legal-counselling':
      return <LegalCounsellingForm form={form} isView={isView} />

    case 'documentation':
      return <DocumentationForm form={form} isView={isView} />

    case 'oaths-administered':
      return <OathAdministeredForm form={form} isView={isView} />

    case 'jail-visit':
      return <JailVisitForm form={form} isView={isView} />

    case 'representation-court':
      return <RepresentationCourtForm form={form} isView={isView} courts={courts} />

    case 'representation-appellate':
      return <RepresentationAppellateForm form={form} isView={isView} courts={courts} />

    case 'prosecutor-office':
      return <ProsecutorsOfficeForm form={form} isView={isView} />

    case 'labor-cases':
      return <LaborCasesForm form={form} isView={isView} officeCodes={officeCodes} />

    case 'administrative-case':
      return <AdministrativeCaseForm form={form} isView={isView} />

    case 'outreach':
      return <OutreachForm form={form} isView={isView} />

    case 'mediation-conciliation':
      return <MediationConciliationForm form={form} isView={isView} />

    default:
      return null
  }
}
